import { InjectionToken } from '@angular/core';

import type { AppConfig } from './app-config.types';

export const APP_CONFIG = new InjectionToken<AppConfig>('Application Config');
export const APP_BASE_CONFIG = new InjectionToken<AppConfig>('Application Base Config');
